import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
// import { CustomInput } from 'reactstrap';
import RequiredLabel from '../RequiredLabel/RequiredLabel';

const ValidatedCheckbox = (props) => {
    return (
      <Field name={props.name} type="checkbox">
          {({ input, meta }) => (
            <div className="col-sm-12">
              <div className="custom-control custom-checkbox">
                <input className="form-check-input" {...input} type="checkbox" tabIndex={props.tabIndex || 0}/>
                {props.validated ?
                <div>
                  <RequiredLabel style={{marginRight:'25px'}} className="form-check-label font-weight-bold">{props.label}</RequiredLabel>
                  {(meta.submitError || meta.error && meta.touched) && <span className="invalid-feedback" style={{display:'inline'}}>{meta.error ? meta.error : meta.submitError}</span>}
                </div> :
                <label style={{marginRight:'15px'}} className="form-check-label font-weight-bold">{props.label}</label>}
              </div>
            </div>
          )}
      </Field>
    );
  };

  export default ValidatedCheckbox;
  